import { fetchObject, fetchObjectPriceInfo, fetchObjectRecommendationAds, fetchObjectSsr } from '@/api/api';
import { ObjectPriceRange, ObjectPricing } from '@/interfaces';

export const POPULATE_OBJECT_PENDING = 'POPULATE_OBJECT_PENDING';
export const POPULATE_OBJECT_SUCCESS = 'POPULATE_OBJECT_SUCCESS';
export const POPULATE_OBJECT_FAILED = 'POPULATE_OBJECT_FAILED';
export const CLEAR_OBJECT = 'CLEAR_OBJECT';
export const FETCH_OBJECT_RECOMMENDATION_SUCCESS = 'FETCH_OBJECT_RECOMMENDATION_SUCCESS';
export const FETCH_OBJECT_RECOMMENDATION_FAILED = 'FETCH_OBJECT_RECOMMENDATION_FAILED';
export const FETCH_OBJECT_PRICE_INFO_SUCCEEDED = 'objectActions/FETCH_OBJECT_PRICE_INFO_SUCCEEDED';
export const FETCH_OBJECT_PRICE_INFO_FAILED = 'objectActions/FETCH_OBJECT_PRICE_INFO_FAILED';

const populateObjectPending = (adId) => ({
    type: POPULATE_OBJECT_PENDING,
    adId,
});

const populateObjectSuccess = (data) => ({
    type: POPULATE_OBJECT_SUCCESS,
    data,
});

const populateObjectFailed = (error) => ({
    type: POPULATE_OBJECT_FAILED,
    error,
});

export const clearObject = () => ({
    type: CLEAR_OBJECT,
});

const fetchObjectRecommendationsSuccess = (data) => ({
    type: FETCH_OBJECT_RECOMMENDATION_SUCCESS,
    data,
});

const fetchObjectRecommendationsFailed = (error) => ({
    type: FETCH_OBJECT_RECOMMENDATION_FAILED,
    error,
});

const fetchObjectPriceInfoSucceeded = (data) => ({
    type: FETCH_OBJECT_PRICE_INFO_SUCCEEDED,
    data,
});

const fetchObjectPriceInfoFailed = (error) => ({
    type: FETCH_OBJECT_PRICE_INFO_FAILED,
    error,
});

export const populateObjectPriceInfo = (adId) => (dispatch) =>
    fetchObjectPriceInfo(adId)
        .then((data) => {
            const parsedData = parsePriceData(data);
            dispatch(fetchObjectPriceInfoSucceeded(parsedData));
        })
        .catch((error) => {
            dispatch(fetchObjectPriceInfoFailed(error));
        });

type FetchedPriceSummary = {
    priceInfo: { currency: string };
    priceRanges: { day: ObjectPriceRange; week: ObjectPriceRange; weekend: ObjectPriceRange };
    additionalCost?: { priceDepositType: string; priceDepositAmount: number; priceCleaning: number; priceLinens: number };
};

const isFetchedPriceSummary = (data: unknown): data is FetchedPriceSummary =>
    typeof data === 'object' && typeof (data as FetchedPriceSummary)?.priceInfo?.currency === 'string';

const parsePriceData = (data: unknown): ObjectPricing | never => {
    if (isFetchedPriceSummary(data)) {
        return {
            currency: data.priceInfo.currency,
            day: data.priceRanges.day,
            weekend: data.priceRanges.weekend,
            week: data.priceRanges.week,
            cleaning: data.additionalCost?.priceCleaning,
            linens: data.additionalCost?.priceLinens,
            depositAmount: data.additionalCost?.priceDepositAmount,
            depositType: data.additionalCost?.priceDepositType,
            year: null,
        };
    }
    throw new Error(`Data is not of correct format: ${JSON.stringify(data)}`);
};

export const populateObject = (adId) => (dispatch) => {
    dispatch(populateObjectPending(adId));

    return fetchObject(adId)
        .then((data) => {
            dispatch(populateObjectSuccess(data));
        })
        .catch((error) => {
            dispatch(populateObjectFailed(error));
        });
};

export const populateObjectSsr = (adId, options) => (dispatch) => {
    dispatch(populateObjectPending(adId));

    return fetchObjectSsr(adId, options)
        .then((data) => dispatch(populateObjectSuccess(data)))
        .catch((error) => dispatch(populateObjectFailed(error)));
};

export const populatePreviewObjectSsr = (adId, options) => (dispatch) => {
    dispatch(populateObjectPending(adId));

    return fetchObjectSsr(adId, { ...options, isPreview: true })
        .then((data) => dispatch(populateObjectSuccess({ ...data, isPreview: true })))
        .catch((error) => dispatch(populateObjectFailed(error)));
};

export const fetchObjectRecommendations = (adId) => (dispatch) =>
    fetchObjectRecommendationAds(adId)
        .then((data) => dispatch(fetchObjectRecommendationsSuccess(data)))
        .catch((error) => dispatch(fetchObjectRecommendationsFailed(error)));
